export const styles = {
  dialogPaper: {
    borderRadius: "12px",
    maxWidth: "556px",
    width: "100%",
  },
  headerBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: "24px",
    py: "16px",
    borderBottom: "1px solid rgba(234, 234, 234, 1)",
  },
  dialogTitle: {
    fontWeight: 500,
    color: "rgba(47, 43, 61, 0.9)",
    fontSize: "18px",
    lineHeight: "28px",
    p: 0,
    m: 0,
  },
  closeIcon: {
    color: "rgba(62, 63, 76, 1)",
  },
  dialogContent: {
    p: "24px",
    pb: "32px",
    pt: "32px",
  },
  descriptionStyle: {
    fontSize: "15px",
    fontWeight: 400,
    color: "rgba(47, 43, 61, 0.9)",
    lineHeight: "160%",
  },
  dialogActions: {
    px: "24px",
    py: "12px",
  },
  actionButton: {
    backgroundColor: "rgba(37, 124, 109, 1)",
    color: "white",
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "15px",
    fontWeight: 500,
    px: "16px",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "rgba(30, 109, 91, 1)",
    },
  },

  loader: {
    color: "rgba(255, 255, 255, 1)",
    ml: "8px",
  },
};
